export const labelIdSuffix = "-label";
export const nameIdSuffix = "-name";
export const baseAddPharmacyClassName = "SelectPharmaciesPage__addPharmacy";
